import { createFileRoute } from '@tanstack/react-router'
import { ClinicPicker } from '@pa/staff'

/** The clinic picker (Frontend §5.2). */
export const Route = createFileRoute('/_authed/select-clinic')({
  component: function SelectClinicRoute() {
    const { me } = Route.useRouteContext()
    return <ClinicPicker siteName="PF Appointments" me={me} />
  },
})
